export default "__VITE_ASSET__BECMRj7G__"